module.exports = __webpack_public_path__ + "img/chillidog.baa91465.jpeg";